import { render, staticRenderFns } from "./CandidateRowSimilar.vue?vue&type=template&id=761f71d9&scoped=true&lang=pug"
import script from "./CandidateRowSimilar.vue?vue&type=script&lang=js"
export * from "./CandidateRowSimilar.vue?vue&type=script&lang=js"
import style0 from "./CandidateRowSimilar.vue?vue&type=style&index=0&id=761f71d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761f71d9",
  null
  
)

export default component.exports